<template>
  <div>
    <div class="ratio ratio-16x9">
      <iframe
        ref="video"
        :src="`https://www.youtube.com/embed/${youtube_id}`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>

      <div
        class="d-flex justify-content-center align-items-center w-100 h-100"
        style="z-index: -1"
      >
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['component'],
  computed: {
    youtube_id() {
      return _.get(this.component, 'video', '')
    },
  },
}
</script>
